export default __webpack_public_path__ + "static/media/search_icon.6d788f61.svg";